import { BsPersonGear } from "react-icons/bs";
import { IoLogOut } from "react-icons/io5";
import GameIcon from "../components/icons/GameIcon";
import IconlyCurvedBold3User from "../components/icons/IconlyCurvedBold3User";
import IconlyCurvedBoldCalendar from "../components/icons/IconlyCurvedBoldCalendar";
import IconlyCurvedBoldChat from "../components/icons/IconlyCurvedBoldChat";
import IconlyCurvedBoldFolder from "../components/icons/IconlyCurvedBoldFolder";
import IconlyCurvedBoldPaper from "../components/icons/IconlyCurvedBoldPaper";
import IconlyRegularBoldCategory from "../components/icons/IconlyRegularBoldCategory";
import { LogOut } from "../components/redirects/LogOut";
import { RedirectToLoginIfNotAuthenticated } from "../components/redirects/RedirectToLoginIfNotAuthenticated";
import { RedirectToPersonalIfAuthenticated } from "../components/redirects/RedirectToPersonalIfAuthenticated";
import { color_red_default } from "../constants/colors";
import LoginPage from "../pages/authorization/LoginPage";
import RecoveryPage from "../pages/authorization/RecoveryPage";
import RegisterPage from "../pages/authorization/RegisterPage";
import TariffSelection from "../pages/authorization/TariffSelection";
import CritterQuiz from "../pages/games/CritterQuiz";
import Hangman from "../pages/games/Hangman";
import HorseRace from "../pages/games/HorseRace";
import MagicSentence from "../pages/games/MagicSentence";
import StoryBuilder from "../pages/games/StoryBuilder";
import TalkQuest from "../pages/games/TalkQuest";
import WhatsMissing from "../pages/games/WhatsMissing";
import { FailNewRecurrentPage } from "../pages/payments/FailNewRecurrentPage";
import { SuccessNewRecurrentPage } from "../pages/payments/SuccessNewRecurrentPage";
import { AdminPage } from "../pages/personal/AdminPage";
import { BillingPage } from "../pages/personal/BillingPage";
import { GamesPage } from "../pages/personal/GamesPage";
import JournalPage from "../pages/personal/JournalPage";
import { LessonsProgram } from "../pages/personal/LessonsProgram";
import { LevelLessonsPage } from "../pages/personal/LevelLessonsPage";
import { LibraryPage } from "../pages/personal/LibraryPage";
import PersonalPage from "../pages/personal/PersonalPage";
import { ScheduleDayExtended } from "../pages/personal/schedule/ScheduleDayExtended";
import { SchedulePage } from "../pages/personal/schedule/SchedulePage";
import { StudentPage } from "../pages/personal/StudentPage";
import SupportPage from "../pages/personal/SupportPage";
import { Updates } from "../pages/personal/Updates";
import { AppRoute } from "./AppRoute";
import { MenuRoute } from "./MenuRoute";
import { ProtectedAppRoute } from "./ProtectedAppRoute";

export const routeList = [
  new AppRoute(
    "/",
    <RedirectToLoginIfNotAuthenticated>
      <PersonalPage />
    </RedirectToLoginIfNotAuthenticated>,
  ),
  new AppRoute(
    "/auth/login",
    <RedirectToPersonalIfAuthenticated>
      <LoginPage />
    </RedirectToPersonalIfAuthenticated>,
  ),
  new AppRoute(
    "/auth/register",
    <RedirectToPersonalIfAuthenticated>
      <RegisterPage />
    </RedirectToPersonalIfAuthenticated>,
  ),
  new AppRoute(
    "/auth/recovery",
    <RedirectToPersonalIfAuthenticated>
      <RecoveryPage />
    </RedirectToPersonalIfAuthenticated>,
  ),
  new AppRoute("/auth/tariffs", <TariffSelection />),
  new AppRoute("/billing", <BillingPage />),
  new ProtectedAppRoute("/admin", <AdminPage />),
  new AppRoute("/payments/successNewRecurrent", <SuccessNewRecurrentPage />),
  new AppRoute("/payments/failNewRecurrent", <FailNewRecurrentPage />),
  new MenuRoute(
    "/service/personal",
    <PersonalPage />,
    (props) => <IconlyCurvedBold3User {...props} />,
    "Личный кабинет",
  ),
  new MenuRoute(
    "/service/schedule",
    <SchedulePage />,
    (props) => <IconlyCurvedBoldCalendar {...props} />,
    "Мое расписание",
  ),
  new MenuRoute(
    "/service/journal",
    <JournalPage />,
    (props) => <IconlyCurvedBold3User {...props} />,
    "Журнал учеников",
  ),
  new MenuRoute(
    "/service/program",
    <LessonsProgram />,
    (props) => <IconlyCurvedBoldPaper {...props} />,
    "Программа",
  ),
  new MenuRoute(
    "/service/games",
    <GamesPage />,
    (props) => <GameIcon {...props} />,
    "Игры",
  ),

  new ProtectedAppRoute("/game/whats-missing", <WhatsMissing />),

  new ProtectedAppRoute("/game/magic-sentence", <MagicSentence />),

  new ProtectedAppRoute("/game/hangman", <Hangman />),

  new ProtectedAppRoute("/game/horse-race", <HorseRace />),

  new ProtectedAppRoute("/game/talk-quest", <TalkQuest />),

  new ProtectedAppRoute("/game/story-builder", <StoryBuilder />),

  new ProtectedAppRoute("/game/critter-quiz", <CritterQuiz />),

  new MenuRoute(
    "/service/library",
    <LibraryPage />,
    (props) => <IconlyCurvedBoldFolder {...props} />,
    "Библиотека",
  ),
  new MenuRoute(
    "/service/updates",
    <Updates />,
    (props) => <IconlyRegularBoldCategory {...props} />,
    "Обновления",
  ),
  new MenuRoute(
    "/service/support",
    <SupportPage />,
    (props) => <IconlyCurvedBoldChat {...props} />,
    "Поддержка",
  ),
  new ProtectedAppRoute(
    "/service/students/:studentId",
    <StudentPage />,
    <BsPersonGear />,
    "student1",
  ),
  new MenuRoute(
    "/logout",
    <LogOut />,
    <IoLogOut style={{ color: color_red_default }} />,
    "Выйти",
  ),
  new ProtectedAppRoute(
    "/service/program/level/:levelId",
    <LevelLessonsPage />,
  ),
  new ProtectedAppRoute("/service/schedule/day", <ScheduleDayExtended />),
];

export const menuRouteList = routeList.filter((el) => el instanceof MenuRoute);
